import React, { PureComponent, Component } from 'react';
import CheckDefecto from '../../../../Common/Components/CheckDefecto'

class Diaria extends Component {
    constructor(props) {
        super(props)
        this.selectRadio = this.selectRadio.bind(this);
    }


    selectRadio(value) {
        this.props.selectRadio("Periodicidad", value)

    }

    render() {

        const {proceso, calendario, setCheck} = this.props;
        
        return (
            <div style={{marginLeft:"20px"}} className="row top-separator-xs">
                <div className="row row-radio">
                    <div className="col-xs-12">
                        <div className="container-radio radio-margin">
                            <input id={"rbDiaria" + 1}
                                type="radio"
                                name="rbDiaria"
                                value={true}
                                data-value={"Diario"}
                                checked={proceso.Periodicidad == "Diario"}
                                onChange={(event) => this.selectRadio(event.target.dataset.value)} />
                            />
                                <label style={{marginLeft:"12px"}}
                                className="lbl-radio label-secondary"
                                htmlFor={"rbDiaria" + 1}>
                                {"Diaria"}
                            </label>
                        </div>
                    </div>
                </div>

                <CheckDefecto   
                    style={{marginLeft:"20px"}}             
                    nombre={"Solo días hábiles"}
                    referencia={"DiasHabiles" + 0}
                    id={"DiasHabiles" + 0}
                    activo={proceso.Periodicidad == "Diario"}
                    check={calendario.DiaHabil && proceso.Periodicidad == "Diario"}
                    selectCheckBox={(event) => setCheck("DiaHabil", event.target.checked)}                    
                />

            </div>
        )
    }
};

export default Diaria;